import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap';
import Modal from '../../../../../../../components/Modal';

const NewResourceSetNameModal = ({ showModal, setShowModal, newSetName, setNewSetName, handleCreateNewResourceSet }) => {

  const handleNewSetNameValidation = (event) => {
    var inputValue = event.target.value;

    if (inputValue.length > 100) {
      event.target.setCustomValidity('Name must be 100 characters or less!');
    } else {
      event.target.setCustomValidity('');
    }
  };
  
  return (
    <>
      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        titleName='Create Resource Set'
        contentWidth='40%'>
        <Form className='d-flex flex-row' onSubmit={(e) => handleCreateNewResourceSet(e)}>
          <Form.Group id='setName' className='w-100'>
            <Form.Label>Set Name</Form.Label>

            <div className='d-flex flex-row gap-3 align-items-center'>
              <Form.Control
                type='text'
                className='w-100'
                defaultValue={newSetName}
                onChange={(e) => setNewSetName(e.target.value)}
                onInput={handleNewSetNameValidation}
                required
              />
              <Button
                disabled={newSetName.length <= 0}
                variant='castleRed'
                className='btn-width'
                type='submit'>
                Save
              </Button>
            </div>
          </Form.Group>
        </Form>
      </Modal>
    </>
  );
};

NewResourceSetNameModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  setName: PropTypes.string,
  setSetName: PropTypes.func
};

export default NewResourceSetNameModal;
